import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  const reduced = useReducedMotion();
  if (reduced) {
    return <div className={className} data-id="element-188" data-mp="3ggfr2fcyl52p">{children}</div>;
  }
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.5,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-189" data-mp="3gitk6io2w77m">
      {children}
    </motion.div>;
}